import { useCallback } from 'react';
import { useRoleByIdQuery } from 'api';
import { ADMIN_ROUTES } from 'constants/routes';
import { useNavigate, useParams } from 'react-router-dom';

export const useDetails = () => {
  const { id } = useParams() as { id: string };
  const { data: roleDetails = {} } = useRoleByIdQuery({ id });
  const navigate = useNavigate();

  const onUpdateClick = useCallback(() => {
    navigate(`${ADMIN_ROUTES.role.update}/${id}`);
  }, [navigate, id]);

  return {
    roleDetails,
    onUpdateClick,
  };
};
